module.exports = {
  'Required::NON_EXISTENT_KEY': 'To pole jest wymagane',
  'NotEmpty::EMPTY_VALUE': 'To pole jest wymagane'
}
